"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var TabStyles_1 = require("../styles/TabStyles");
var TypeStyle = require("typestyle");
var getProgressBarContainerStyle = function () {
    return {
        backgroundColor: TabStyles_1.TabStyles.Colors.F3,
        borderRadius: TabStyles_1.TabStyles.Sizing.BorderRadius,
        height: TabStyles_1.TabStyles.Sizing.BaseUnit,
        position: 'relative',
    };
};
exports.ProgressBarContainer = function (props) {
    var style = tslib_1.__assign(tslib_1.__assign({}, getProgressBarContainerStyle()), { width: props.width });
    return React.createElement("div", { style: style, children: props.children });
};
var getProgressBarStyle = function () {
    return {
        backgroundColor: TabStyles_1.TabStyles.Colors.GoLight,
        height: '100%',
        left: 0,
        position: 'absolute',
        top: 0,
    };
};
exports.ProgressCompleteBar = function (props) {
    var style = tslib_1.__assign(tslib_1.__assign({}, getProgressBarStyle()), { width: 100 * props.fractionComplete + "%" });
    return React.createElement("div", { style: style, children: props.children });
};
var getProgressBarAnimationWidth = function () { return TabStyles_1.TabStyles.Sizing.BaseUnit; };
var getProgressBarAnimationStaticStyle = function () {
    return {
        backgroundColor: TabStyles_1.TabStyles.Colors.GoDark,
        height: '100%',
        position: 'absolute',
        top: 0,
        width: getProgressBarAnimationWidth(),
    };
};
exports.ProgressBarAnimation = function (_a) {
    var containerWidth = _a.containerWidth;
    var animationClassName = TypeStyle.style({
        animationDirection: 'alternate',
        animationDuration: '1000ms',
        animationIterationCount: 'infinite',
        animationName: TypeStyle.keyframes({
            '0%': { transform: "translate3d(0px, 0px, 0px)" },
            '100%': { transform: "translate3d(" + (containerWidth - getProgressBarAnimationWidth()) + "px, 0px, 0px)" },
        }),
        animationTimingFunction: 'ease-in-out',
    });
    return React.createElement("div", { className: animationClassName, style: getProgressBarAnimationStaticStyle() });
};
//# sourceMappingURL=ProgressBarWidgets.js.map